import { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import CanvasAddProductButton from "../../../sharable/CanvasAddProductButton";
import EncarteProduct from "../../../sharable/EncarteProduct/EncarteProduct";
import EncarteTrialVersionMarketingMessage from "../../../sharable/EncarteTrialVersionMarketingMessage";
import FooterStyles, {
  getFeedFooterRowHeight,
  useFooterNotice,
} from "../../../sharable/SocialCanvasFooterStyles";
import { BRAND_VIEW } from "../../ToolBarMenuViews/Toolbar";
import WorkspaceContext from "../../WorkspaceContext";
import {
  BrandLogo,
  calcProductStylesOcurrence,
  Canvas,
  GridProducts,
  Header,
} from "../Canvas/CanvasGeneralStyles";
import {
  CANVAS_TARGET_CLASSNAME,
  FEED_INSTAGRAM,
  FEED_INSTAGRAM_DIM,
  FEED_INSTAGRAM_PORTRAIT_DIM,
  LOGO_SIZE_SMALL,
  MAX_PRODUCTS_FEED_FORMAT,
} from "../EncarteConstants";

const FeedCanvasContainer = styled(Canvas)`
  ${({ canvasScale }) => css`
    background-position-y: ${-220 * canvasScale}px;
  `}
`;

const FeedHeader = styled(Header)``;
const FeedGridProducts = styled(GridProducts)``;

export default function FeedCanvas({
  isTargetCanvas = false,
  grid,
  products,
  canvasScale,
  isProductClickable,
}) {
  const { styles, encarte, model, userBrand, scrollIntoMenu } =
    useContext(WorkspaceContext);
  const [headerAndFooterStyles, setHeaderAndFooterStyles] = useState({});

  useEffect(() => {
    if (!products || products.length === 0) {
      setHeaderAndFooterStyles(null);
      return;
    }
    setHeaderAndFooterStyles(calcProductStylesOcurrence(products));
  }, [products]);

  const footerNotice = useFooterNotice();
  const footerRowHeight = getFeedFooterRowHeight(
    styles.footerStyle,
    canvasScale,
    Boolean(footerNotice),
  );

  const dimensions =
    styles.format === FEED_INSTAGRAM
      ? FEED_INSTAGRAM_DIM
      : FEED_INSTAGRAM_PORTRAIT_DIM;
  return (
    <FeedCanvasContainer
      canvasScale={canvasScale}
      styles={styles}
      model={model}
      dimensions={dimensions}
      className={isTargetCanvas && CANVAS_TARGET_CLASSNAME}
      footerRowHeight={footerRowHeight}
    >
      <FeedHeader>
        <BrandLogo
          logo={userBrand.logoURLTmp}
          canvasScale={canvasScale}
          logoSize={styles.logoSize}
          logoStyle={styles.logoStyle}
          headerStyles={headerAndFooterStyles}
          onClick={() => {
            if (isProductClickable) scrollIntoMenu(BRAND_VIEW);
          }}
          position={{ bottom: 15, right: 10 }}
          size={LOGO_SIZE_SMALL}
        />
      </FeedHeader>
      {grid && products.length > 0 ? (
        <>
          <FeedGridProducts
            grid={grid}
            styles={styles}
            hasGrid={grid}
            canvasScale={canvasScale}
          >
            {products.slice(0, MAX_PRODUCTS_FEED_FORMAT).map((product, i) => (
              <EncarteProduct
                product={product}
                canvasScale={canvasScale}
                styles={styles}
                index={i}
                isProductClickable={isProductClickable}
                productsLength={products.length}
              />
            ))}
          </FeedGridProducts>
          {/* <EncarteTrialVersionMarketingMessage canvasScale={canvasScale} /> */}
        </>
      ) : (
        <CanvasAddProductButton dimensions={FEED_INSTAGRAM_PORTRAIT_DIM} />
      )}
      {headerAndFooterStyles && (
        <FooterStyles
          headerAndFooterStyles={headerAndFooterStyles}
          canvasScale={canvasScale}
        />
      )}
    </FeedCanvasContainer>
  );
}
